export const ShopNavbar = () => {
  return (
    <div className="shop-navbar">
      <a href="bouquets">Bukiety</a>
      <a href="compositions">Kompozycje</a>
      <a href="cemetery">Kompozycje nagrobne</a>
      <a href="wreaths">Wieńce pogrzebowe</a>
    </div>
  );
};
